import { dayjs } from 'src/app/dayjs.lib';
import { Ticket, TicketEntitlement } from '../../../core/api/responses/booking-portal-login';
import { EventCalendar } from '../models/event-calendar.model';

export interface BookingsState {
	bookings: Booking[];
	events: EventCalendar[];
	openEntitlement: {
		ticket: Ticket;
		entitlement: TicketEntitlement;
		newBookingDate?: dayjs.Dayjs;
		newBookingTime?: string;
	};
	swFailedCount?: number;
}

export interface Booking {
	orderId: string;
	tickets: Ticket[];
}

export const initialState: BookingsState = {
	bookings: [],
	events: [],
	openEntitlement: null,
};
